<template>
  <div>
    <SectionHeader />
    <v-main id="main_content" tabindex="-1" class="pb-6">
      <router-view />
    </v-main>
    <mobile-nav v-if="$vuetify.display.xs" />
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FooterComponent from '@/components/Footer/Footer.vue';
import MobileNav from '@/components/MobileNav.vue';
import SectionHeader from '@/components/SectionHeader.vue';

export default defineComponent({
  name: 'MainLayout',
  components: {
    SectionHeader,
    MobileNav,
    FooterComponent,
  },
});
</script>
<style lang="scss" scoped>
.language-dropdown {
  padding-right: 113px;
}
.sing-in {
  padding-right: 85px;
}
</style>
